.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 14px;
  line-height: 1.2;
  color: var(--color-text);
  background: transparent;
  border: 1px solid var(--color-divider);
  border-radius: var(--radius-md);
}
.button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.primary {
  background: var(--color-accent);
  border-color: var(--color-accent);
  color: var(--color-bg);
}
.primary:hover {
  background: var(--color-accent-600);
}
.primary:active {
  background: var(--color-accent-700);
  border-color: var(--color-accent-700);
}

.secondary:hover {
  background: color-mix(in srgb, var(--color-text) 7%, transparent);
}
.secondary:active {
  background: color-mix(in srgb, var(--color-text) 14%, transparent);
}

.ghost {
  color: var(--color-accent);
  border-color: transparent;
}
.ghost:hover {
  background: color-mix(in srgb, var(--color-accent) 10%, transparent);
}
.ghost:active {
  background: color-mix(in srgb, var(--color-accent) 18%, transparent);
}

.danger {
  background: var(--color-danger);
  border-color: var(--color-danger);
  color: #ffffff;
}
.danger:hover,
.danger:active {
  background: var(--color-danger-700);
  border-color: var(--color-danger-700);
}

.xs {
  padding: 12px 20px;
}
.sm {
  padding: 12px 22px;
}
.md {
  padding: 14px 28px;
}
.lg {
  padding: 16px 28px;
}
.cta {
  padding: 16px 26px;
  font-size: 15px;
}
.xl {
  padding: 18px 34px;
  font-size: 16px;
}
